var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',[_c('b-container',[_c('h2',[_vm._v(" "+_vm._s(_vm.$t("label_"+_vm.getLower(_vm.getTemplateId)+"_title"))+" "),(_vm.business)?_c('span',{staticClass:"business"},[_vm._v("/ "+_vm._s(_vm.business))]):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }